import calculateGridDateFromPoint from '../calculation/calculateGridDateFromPoint';
import { action } from 'satcheljs/lib/legacy';
import { initializeDragOperation } from './initializeDragOperation';
import { isDragging } from './isDragging';
import { setDragStartPosition } from './setDragStartPosition';
import {
    SurfaceDragDropConfig,
    DroppableType,
    DragOperationType,
    CalendarSurfaceStore,
    ColumnProvider,
} from 'owa-calendar-surface-dategrid';
import { DragData } from 'owa-dnd/lib/utils/dragDataUtil';

/**
 * Handles setting dragDropState properties when an item is dragged onto the calendar surface.
 * This is needed for cases where an item is dragged from outside the calendar surface onto it
 * because in this case SurfaceDraggable won't get a chance to run (because we aren't dragging from it)
 * @param surfaceStore The surface store
 * @param dragDropConfig drag and drop config
 * @param columnProvider The column provider that can place the model in the desired column.
 * @param droppableElement The html element for the droppable region over which we are dragging
 * @param droppableType The type of droppable, i.e., day/week, all-day
 * @param dragPositionX: The page x position where we are dragging
 * @param dragPositionY: The page y position where we are dragging
 * @param dragItemType The type of drag operation being performed, i.e., drag/resize
 */
export let handleStartDragOntoSurface = action('handleStartDragOntoSurface')(
    function handleStartDragOntoSurface(
        surfaceStore: CalendarSurfaceStore,
        dragDropConfig: SurfaceDragDropConfig,
        columnProvider: ColumnProvider,
        droppableElement: HTMLElement,
        droppableType: DroppableType,
        dragPositionX: number,
        dragPositionY: number,
        dragInfo: DragData
    ): void {
        let { dragDropState } = surfaceStore;
        if (isDragging(dragDropState) || !dragDropConfig.getSurfaceItemForPreview) {
            return;
        }

        let dragOffsetDate = calculateGridDateFromPoint(
            surfaceStore,
            columnProvider,
            droppableElement,
            droppableType,
            dragPositionX,
            dragPositionY
        );

        let draggedItemModel = dragDropConfig.getSurfaceItemForPreview(
            dragInfo,
            dragOffsetDate,
            droppableType
        );

        setDragStartPosition(surfaceStore, dragPositionX, dragPositionY);
        initializeDragOperation(surfaceStore, draggedItemModel, DragOperationType.Drag);
    }
);
